<template>
  <v-card>
        <FCCRefereeApplication ref="appRed" :runs="this.runs" :index="this.startId * 2" :red="this.red" />
        <FCCRefereeApplication ref="appBlue" :runs="this.runs" :index="this.startId * 2 + 1" :red="this.red" v-show="(this.startId * 2 + 1) < this.runs.length" />
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'
  import FCCRefereeApplication from './FCCRefereeApplication.vue'

  export default {
    name: 'FCCRefereeRun',
    data: () => ({
    }),
    computed: {
      isDirty: function() {
        return this.$refs.appRed.isDirty || (this.$refs.appBlue != undefined && this.$refs.appBlue.isDirty);
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        FCCRefereeApplication,
    },
    props: {
      runs: Array,
      startId: Number,
      red: Boolean
    }
  }
</script>